export default {
  checkbox: {
    title: 'Чекбокс',
    value: 'checkbox',
  },
  range: {
    title: 'Диапазон',
    value: 'range',
  }
}